import styles from './styles.scss';
import cn from 'classnames';
import { NotifyLink } from 'components/Shared/NotifyLink';

interface ChildrenProps {
  children: React.ReactNode;
  className?: string;
}

interface SearchHeadingProps extends ChildrenProps {
  hide?: boolean;
}
export const SearchHeading = ({ children, className, hide }: SearchHeadingProps) => (
  <p className={cn(styles.searchHeading, className, { [styles.hide]: hide })}>{children}</p>
);

export const SearchList = ({ children, className }: ChildrenProps) => (
  <ul className={cn(styles.searchList, className)}>{children}</ul>
);

interface SearchListItemProps extends ChildrenProps {
  executeSearch?: (url: string) => void;
  ticket: string;
  url: string;
  reset: () => void;
  selected?: boolean;
}

export const SearchListItem = ({
  children,
  className,
  selected,
  url,
  ticket,
  reset,
  executeSearch
}: SearchListItemProps) => {
  const onClick = () => {
    executeSearch && executeSearch(url);
    reset();
  };

  return (
    <li className={cn(styles.searchListItem, { [styles.selected]: selected }, className)}>
      <NotifyLink onClick={onClick} ticket={ticket} url={url} className={styles.link}>
        {children}
      </NotifyLink>
    </li>
  );
};
